import React, { useState } from "react";
import PropTypes from "prop-types";
import TextComponent from "components/TextComponent";
import CloseImage from "assets/images/general_old/close.svg";
import SelectComponent from "components/SelectComponent";
import { AwardedCreditsReasonType } from "./utils";
import TextAreaSimpleComponent from "components/TextAreaSimpleComponent";
import ButtonComponent from "components/ButtonComponent";
import { AwardCreditsSchema } from "./FieldValidationRoles";
import { CallAPI } from "actions/General";
import CustomModal from "components/CustomModal";

function AwardCredits({
  AwardCreditsObj,
  setAwardCreditsObj,
  fetchScheduleDetails,
}) {
  console.log(AwardCreditsObj);
  // credits: number;
  // reason_type: string;
  // reason_detail: string;
  // user_id: string;
  // schedule_id: string;

  const [values, setValues] = useState({
    credits: 0,
    reason_type: "",
    reason_detail: "",
  });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [apiError, setApiError] = useState("");

  const updateFormValues = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const saveAwardCredits = async () => {
    try {
      setErrors({});
      await AwardCreditsSchema.validate(values, { abortEarly: false });
      const result = await CallAPI(
        "AWARD_CREDITS_TO_USER",
        {
          ...values,
          credits: parseInt(values.credits),
          user_id: AwardCreditsObj.user_id,
          schedule_id: AwardCreditsObj.schedule_id,
        },
        null,
        setLoader,
        setApiError,
        null
      );
      if (result.status) {
        setAwardCreditsObj(null);
        fetchScheduleDetails();
      }
    } catch (error) {
      console.log(error);

      console.log("error", error);
      const schemaErrors = {};
      error.inner?.forEach((err) => {
        schemaErrors[err.path] = err.message;
      });
      console.log(schemaErrors);

      setErrors(schemaErrors);
    }
  };
  const closeErrorModal = () => {
    setApiError("");
  };
  return (
    <div className={`custom-modal `}>
      <div className="detail">
        <h3 className="text-center mb-5">Award Credits</h3>
        <img
          className="close"
          src={CloseImage}
          onClick={() => setAwardCreditsObj(null)}
          alt="close"
        />
        <div className="d-flex flex-column gap-3">
          <TextComponent
            name={"credits"}
            label={"enter_awarded_credits"}
            placeholder={"credits"}
            value={values.credits}
            setValue={updateFormValues}
            classes={""}
            error={errors["credits"] ?? ""}
            required={true}
            type="number"
          />
          <SelectComponent
            name={"reason_type"}
            label={"reason_type"}
            value={values.reason_type}
            error={errors["reason_type"] ?? ""}
            classes={""}
            onChange={updateFormValues}
            optionsList={AwardedCreditsReasonType}
            required={true}
          />
          <TextAreaSimpleComponent
            name={"reason_detail"}
            label={"reason_details"}
            placeholder={"reason_details"}
            value={values.reason_detail}
            setValue={updateFormValues}
            classes={""}
            error={errors["reason_detail"] ?? ""}
            required={true}
            type="number"
          />
          <ButtonComponent
            text={"save"}
            variant="blue-1"
            onClick={saveAwardCredits}
            loading={loader}
            disabled={loader}
          />
        </div>
      </div>
      {apiError && (
        <CustomModal
          header={""}
          text={apiError}
          buttons={[
            {
              text: "ok",
              variant: "blue-1",
              onClick: "closeErrorModal",
              loading: false,
              disabled: false,
            },
          ]}
          onClose={closeErrorModal}
          variant={"error"}
          functionsList={{ closeErrorModal }}
        />
      )}
    </div>
  );
}

AwardCredits.propTypes = {
  AwardCreditsObj: PropTypes.object.isRequired,
  setAwardCreditsObj: PropTypes.func.isRequired,
  fetchScheduleDetails: PropTypes.func.isRequired,
};
export default AwardCredits;
